'use strict';

/**
 * View for rendering a single set in sub navigation
 *
 * @category   View
 * @module     entities
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/navigation-sets-list-item.hbs');

var NavigationSetsListItemView = ColidoItemView.extend({
    template: template,

    tagName: 'li',

    modelEvents: {
        'change sync': 'render',
    },
});

module.exports = NavigationSetsListItemView;